import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function TwoWeeksIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4133" data-mp="1cnx053j5y4pm">
      <div className="relative w-full h-full bg-gradient-to-br from-sky-100 to-blue-200 overflow-hidden" data-id="element-4134" data-mp="12ylr1gwa101q">
        {/* Background: Calendar grid */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4135" data-mp="y0bv342q9vf2">
          <rect x="30" y="40" width="140" height="120" rx="10" fill="#FFFFFF" stroke="#CBD5E1" strokeWidth="2" data-id="element-4136" data-mp="oz3xko81cym1" />
          <rect x="30" y="40" width="140" height="22" rx="10" fill="#3B82F6" data-id="element-4137" data-mp="3lbdmxcy3q1q8" />
          {/* Two weeks of day cells */}
          {[...Array(2)].map((_, row) => [...Array(7)].map((_, col) => {
          const x = 38 + col * 18;
          const y = 72 + row * 22;
          const done = isUnlocked;
          return <circle key={`${row}-${col}`} cx={x} cy={y} r="6" fill={done ? '#22C55E' : '#E2E8F0'} data-id="element-4138" data-mp="8us8v249g9sq" data-mpi={col} />;
        }))}
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[6%]" data-id="element-4139" data-mp="3v42vo029p1hv">
          <div className="w-[52%] h-[52%] flex items-center justify-center" data-id="element-4140" data-mp="3tugxxtg81e1">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'happy' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4141" data-mp="2jm1v17qage9t" />
          </div>
        </div>

        {/* Foreground: check marks */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4142" data-mp="1vqyfaivbb18c">
            <path d="M150 30 l6 6 l12 -14" stroke="#22C55E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" data-id="element-4143" data-mp="1ltkajgir40vv" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}